import { render, staticRenderFns } from "./10introduce.vue?vue&type=template&id=427d0cbc&scoped=true&"
import script from "./10introduce.vue?vue&type=script&lang=js&"
export * from "./10introduce.vue?vue&type=script&lang=js&"
import style0 from "./10introduce.vue?vue&type=style&index=0&id=427d0cbc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427d0cbc",
  null
  
)

export default component.exports